import { useState, useCallback } from 'react';
import { Dayjs } from 'dayjs';
import { FacilityReportFilters } from '../../../services/ReportingService';

const emptyFilters: FacilityReportFilters = { centerId: '', issueType: '', fromDate: '', toDate: '' };

export function useWorkOrderReportFilters() {
  const [filters, setFilters] = useState<FacilityReportFilters>(emptyFilters);
  const [appliedFilters, setAppliedFilters] = useState<FacilityReportFilters>(emptyFilters);
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);

  const handleApplyFilters = useCallback(() => {
    setAppliedFilters({
      ...filters,
      fromDate: fromDate ? fromDate.format('YYYY-MM-DD') : '',
      toDate: toDate ? toDate.format('YYYY-MM-DD') : '',
    });
  }, [filters, fromDate, toDate]);

  const handleResetFilters = useCallback(() => {
    setFilters(emptyFilters);
    setFromDate(null);
    setToDate(null);
    setAppliedFilters(emptyFilters);
  }, []);

  return {
    filters, setFilters,
    appliedFilters,
    fromDate, setFromDate,
    toDate, setToDate,
    handleApplyFilters,
    handleResetFilters,
  };
}
